import { A } from '@angular/cdk/keycodes';
import { Component, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { TransactionRequest, TransactionRequestItem } from 'src/model/transactionRequest.model';
import { TransactionSubType } from 'src/model/transactionSubType.model';
import { TransactionType } from 'src/model/transactionType.model';
import { CompanyService } from 'src/services/company.service';

@Component({
	selector: 'app-add-transaction-request',
	templateUrl: './add-transaction-request.component.html',
	styleUrls: ['./add-transaction-request.component.scss'],
	standalone: false
})
export class AddTransactionRequestComponent implements OnInit {
	protected sharedService = inject(SharedService);
	protected enums = inject(Enums);
	private restApi = inject(RestApiService);
	private constructApi = inject(ConstructAPI);
	private activeModal = inject(NgbActiveModal);
	private companyService = inject(CompanyService);

	transactionRequest: TransactionRequest;
	disabledSubmit = false;
	transactionTypeList: TransactionType[] = [];
	transactionSubtypeList: TransactionSubType[] = [];
	companyList: Company[] = [];
	transactionRequestItemList: TransactionRequestItem[] = [];

	amount: number;
	type: number;
	subtype: number;

	ngOnInit(): void {
		this.transactionRequest = new TransactionRequest(undefined, undefined, undefined, undefined, undefined, undefined, undefined);
		this.getTransactionType();
		this.getAllCompanies();
	}

	addTransactionItem() {
		const amountError = this.amount == undefined && this.amount == 0;
		const typeError = this.type == undefined && this.type == 0;

		if (amountError || typeError) this.sharedService.openAlert('Please fill in all the fields correctly!', ALERT_TYPE.DANGER);
		else {
			const item = { amount: this.amount, type: this.type, subtype: this.subtype };
			this.transactionRequestItemList.push(item);

			this.amount = undefined;
			this.type = undefined;
		}
	}

	getTransactionType() {
		const xhttp = this.restApi.getRequest(this.constructApi.getAllTransactionTypes());
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);

				jsonArray.forEach(json => {
					const type = new TransactionType(json.id, json.name);

					this.transactionTypeList.push(type);
				});

				this.transactionTypeList.sort((a, b) => (a.ID > b.ID ? 1 : -1));
			}
		};
	}

	getTransactionSubTypes(type: number) {
		const xhttp = this.restApi.getRequest(this.constructApi.getTransactionSubTypes(type));

		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);

				jsonArray.forEach(json => {
					const type = new TransactionSubType(json.id, json.name, json.type, json.assignable, json.enabled);
					if (type.Assignable == true) this.transactionSubtypeList.push(type);
				});
			}
		};
	}

	addTransactionRequest() {
		this.disabledSubmit = true;
		const isValid = this.checkBeforeSendingRequest();
		if (isValid) {
			const data = {
				remark: this.transactionRequest.Remark,
				items: this.transactionRequestItemList,
				companyId: Number(this.transactionRequest.CompanyId)
			};

			const xhr = this.restApi.postRequest(this.constructApi.getAddTransactionRequest(), data);
			xhr.onreadystatechange = () => {
				if (xhr.readyState == 4) {
					this.disabledSubmit = false;

					if (xhr.status == 200) {
						this.sharedService.openAlert('Added transaction request !', ALERT_TYPE.SUCCESS);
						window.location.reload();
					} else {
						this.disabledSubmit = false;
						this.sharedService.openErrorMessage(xhr);
					}
				}
			};
		} else {
			this.disabledSubmit = false;
			this.sharedService.openAlert('Please key in all details properly!', ALERT_TYPE.DANGER);
		}
	}

	checkBeforeSendingRequest() {
		const isCompanySelected = this.transactionRequest.CompanyId != undefined;

		const itemExisted = this.transactionRequestItemList.length > 0 && this.transactionRequestItemList != undefined;

		//var isAmountValid = this.transactionRequest.Amount != undefined && this.transactionRequest.Amount != 0;
		//var isTypeSelected = this.transactionRequest.Type != undefined;

		const isRemarkValid = this.transactionRequest.Remark != undefined && this.transactionRequest.Remark != '';

		return isCompanySelected && itemExisted && isRemarkValid;
	}

	private async getAllCompanies() {
		this.companyList = await this.companyService.getAllCompanies();
		this.companyList.sort((a, b) => a.CompanyCode.localeCompare(b.CompanyCode));
	}

	setSelectedCompany(companyID: number) {
		if (companyID === this.transactionRequest.CompanyId) return true;
		else return false;
	}

	reset() {
		this.activeModal.close();
	}
}
